/**
 * Centralized configuration for Auth0 and Backend
 * Validates that all required environment variables are present
 */
import { API_URL } from './appConfig';

interface Auth0Config {
  domain: string;
  clientId: string;
  audience: string;
  organizationId?: string;
  redirectUri: string;
  apiBaseUrl: string;
}

const validateEnvVar = (name: string, value: string | undefined): string => {
  if (!value) {
    throw new Error(`Missing required environment variable: ${name}`);
  }
  return value;
};

// Obtener la URL correcta para redirect basada en el entorno
const getRedirectUri = (): string => {
  if (typeof window === 'undefined') {
    return 'http://localhost:5000';
  }
  
  // En desarrollo, usar la URL actual del navegador
  if (import.meta.env.DEV) {
    return window.location.origin;
  }
  
  // En producción, usar la URL del entorno o window.location.origin como fallback
  return import.meta.env.VITE_APP_URL || window.location.origin;
};

export const auth0Config: Auth0Config = {
  domain: validateEnvVar('VITE_AUTH0_DOMAIN', import.meta.env.VITE_AUTH0_DOMAIN),
  clientId: validateEnvVar('VITE_AUTH0_CLIENT_ID', import.meta.env.VITE_AUTH0_CLIENT_ID),
  audience: validateEnvVar('VITE_AUTH0_AUDIENCE', import.meta.env.VITE_AUTH0_AUDIENCE),
  organizationId: validateEnvVar('VITE_AUTH0_ORG_ID', import.meta.env.VITE_AUTH0_ORG_ID),
  redirectUri: getRedirectUri(),
  apiBaseUrl: API_URL,
};

/**
 * Locale forzado en Universal Login.
 * Auth0 resuelve el idioma en cascada: ui_locales > idioma del navegador > default del tenant.
 */
export const AUTH0_UI_LOCALE = 'en';

// Función para logging de debugging (solo en desarrollo)
export const logAuthEvent = (event: string, data?: unknown) => {
  if (import.meta.env.DEV) {
    console.log(`[Auth0] ${event}`, data);
    console.log(`[Auth0] Redirect URI: ${auth0Config.redirectUri}`);
    console.log(`[Auth0] Current Config:`, {
      domain: auth0Config.domain,
      clientId: auth0Config.clientId,
      audience: auth0Config.audience,
    });
  }
};
